<div @fadeInOutWithBlur style="z-index: 9999999999;"
    class=" bg-amber-950/80 backdrop-blur-xl text-white overflow-auto w-screen h-screen fixed top-0 left-0 flex items-center justify-center gap-4 flex-col"
    *ngIf="dialogVisible">

    <p *ngIf="status == 'idle'" class="text-4xl font-semibold">{{parsedOptions.dialogTitle}}</p>



    <p *ngIf="status == 'idle'" class="text-xl">{{parsedOptions.dialogContent}}</p>





    <ng-content *ngIf="status == 'idle'" select="[dialog-content]"></ng-content>


    <div *ngIf="status == 'idle'" class="w-full flex flex-row justify-center items-center gap-32">

        <button tabindex="0" (click)="cancelClick($event)" id="cancelButtonOverlayMessagge" class="p-4 bg-rose-200 hover:bg-rose-700 transition-all duration-300 text-rose-800
            hover:text-white rounded-2xl flex justify-between items-center gap-2">

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M18 6l-12 12" />
                <path d="M6 6l12 12" />
            </svg>

            <div>
                {{parsedOptions.cancelButtonText ?? 'Annulla'}}
            </div>

        </button>

        <button tabindex="0" (click)="okClick($event)" id="okButtonOverlayMessagge" class="p-4 bg-teal-200 hover:bg-teal-700 transition-all duration-300 text-teal-800
            hover:text-white rounded-2xl flex justify-between items-center gap-2">

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M5 12l5 5l10 -10" />
            </svg>

            <div>
                {{parsedOptions.okButtonText ?? 'Ok'}}
            </div>

        </button>

    </div>

    <div *ngIf="status == 'loading'" class="w-full h-full flex flex-col justify-center items-center">
        <app-animation></app-animation>
        <h1>Caricamento in corso</h1>
    </div>


    <div *ngIf="status == 'response'" class="flex flex-col justify-start items-center gap-4">

        <h1>{{error}}</h1>

        <!-- @if(deleteResponse && deleteResponse.errors && deleteResponse.errors.length > 0) {
        <div style="max-height: 60vh;" class="flex flex-col justify-start items-center gap-4 overflow-auto w-full rounded-2xl">
            <div *ngFor="let group of deleteResponseErrors" class="w-full rounded-2xl">
            
                <app-custom-expansion-panel class="w-full rounded-2xl">

                    <div class="w-full" expansion-header>
                        <h3>{{ group[0].error }}</h3>
                    </div>

                    <div class="w-full flex flex-col justify-start items-start gap-4 " expansion-content>
                        <div *ngFor="let item of group" (click)="navigateToUrl(item.elemUrl)" class="flex justify-between items-center gap-2 w-full cursor-pointer p-2 rounded-2xl bg-white/30 text-white hover:bg-primary-500/30">
                            <p>
                                {{ item.elemName }}
                            </p>
                            
                        </div>
                    </div>

                </app-custom-expansion-panel>

            </div>
        </div>
        } -->

        <div (click)="cancelClick($event)"
            class="p-4 bg-primary-50 hover:bg-primary-500 cursor-pointer transition-all duration-300 text-primary-500 hover:text-white rounded-2xl flex justify-between items-center">
            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M18 6l-12 12" />
                    <path d="M6 6l12 12" />
                </svg> -->
            <p>Ok</p>
        </div>
    </div>


</div>